export default __webpack_public_path__ + "static/media/background-1441.5a08aa6e.jpg";